import { render, staticRenderFns } from "./AdmissionYear.vue?vue&type=template&id=a8ebea60&scoped=true&"
import script from "./AdmissionYear.vue?vue&type=script&lang=js&"
export * from "./AdmissionYear.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionYear.vue?vue&type=style&index=0&id=a8ebea60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ebea60",
  null
  
)

export default component.exports